import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FormSubmit.css'; // Make sure to import the CSS file

function FormSubmit() {
    const navigate = useNavigate();

    return (
        <div className="submit-form-container">
            <div className="submit-form-content">
                <h1 className="submit-form-title">Thank You!</h1>
                <p className="submit-form-text">
                    We appreciate your participation in this survey. Your feedback is valuable to us
                    and will help us improve our services.
                </p>
            </div>
        </div>
    );
}

export default FormSubmit;
